import 'arrive';

document.arrive('.btn-scroll-down', {existing: true}, function(){
    const button = this;
    button.onclick = function() {
        const currSection = button.closest('section');
        const nextSection = currSection.nextElementSibling;
        const dest = nextSection.offsetTop;
        window.scrollTo({ top: dest - document.querySelectorAll('header')[0].offsetHeight, behavior: 'smooth' });
    }
});